import View from './Project';

export default View;
